import { createTheme } from '@mui/material/styles';

// Define color palette
export const colors = {
  background: {
    primary: '#121212',
    secondary: '#1A1A1A',
    paper: '#1A1A1A',
  },
  olive: {
    main: '#556B2F',
    light: 'rgba(85, 107, 47, 0.1)',
  },
  text: {
    primary: '#E0E0E0',
    secondary: '#B0B0B0',
    muted: '#888888',
  },
  accent: {
    border: '#556B2F',
    hover: 'rgba(85, 107, 47, 0.1)',
  }
};

// Create the main theme
export const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: colors.background.primary,
      paper: colors.background.paper,
    },
    primary: {
      main: colors.olive.main,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
  },
  typography: {
    fontFamily: 'Chakra Petch, sans-serif',
    h4: {
      letterSpacing: '0.1em',
      fontWeight: 700,
    },
    h5: {
      letterSpacing: '0.05em',
      fontWeight: 600,
    },
    body1: {
      letterSpacing: '0.02em',
      lineHeight: 1.8,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: `linear-gradient(${colors.olive.light} 1px, transparent 1px), linear-gradient(90deg, ${colors.olive.light} 1px, transparent 1px)`,
          backgroundSize: '20px 20px',
          transition: 'all 0.3s ease-in-out',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Chakra Petch, sans-serif',
          textTransform: 'none',
          borderRadius: '4px',
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          // reduce default horizontal gutters so pages sit closer to the window edge
          paddingLeft: '8px',
          paddingRight: '8px',
          '@media (min-width: 600px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
          },
          '@media (min-width: 1200px)': {
            maxWidth: '1400px',
          },
        },
      },
    },
  },
});

export default theme;
